import React, {Component} from "react";
import {Button, Pagination, FormGroup, FormControl, InputGroup} from "react-bootstrap";
import './paginator.css';
import PropTypes from "prop-types";

/**
 * Paginator component which will have total page,current page  and pageChnage event handler as props and renders view
 */
export default class Paginator extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pageNo !== this.props.pageNo) {
            if (this.textInput) {
                this.textInput.value = this.props.pageNo + 1;
            }
        }
    }

    render() {
        if (this.props.totalPages > 1)
            return (
                <div className=" cusPagination">
                    <Pagination>
                        {this.props.pageNo > 0 ?
                            <Pagination.Prev  href="#"
                                        onClick={() => this.prevPage()}>Previous
                            </Pagination.Prev>
                            :
                            <Pagination.Prev href="#" disabled
                                        onClick={() => this.prevPage()}>Previous
                            </Pagination.Prev>
                        }
                        {/* Paginate via input */}
                        {this.props.totalPages && this.props.totalPages > 0 &&
                            <div className="pagination-wrap">
                                <div className="resetBtn">Page {this.props.pageNo + 1}
                                    of {this.props.totalPages}</div>
                                <FormGroup className="form-group">
                                    <InputGroup className="goToBtn">
                                        <FormControl
                                            ref={input => (this.textInput = input)}
                                            type="text"
                                        />
                                            <Button onClick={() => this.gotoButton()} bsPrefix="input-group-btn">Go to</Button>
                                    </InputGroup>
                                </FormGroup>
                            </div>
                        }
                        {this.props.pageNo + 1 < this.props.totalPages ?
                            <Pagination.Next href="#" onClick={() => this.nextPage()}>Next
                            </Pagination.Next>
                            :
                            <Pagination.Next href="#" disabled
                                        onClick={() => this.nextPage()}>Next
                            </Pagination.Next>
                        }
                    </Pagination>
                </div>
            );
        else {
            return null;
        }
    }

    gotoButton() {
        let pageNo = this.textInput.value;
        if (pageNo.length) {
            pageNo = parseInt(pageNo);
            if (pageNo > 0 && pageNo <= this.props.totalPages) {
                this.firePageChangeEvent(pageNo - 1);
            }
        }
    }

    firePageChangeEvent(pageNo) {
        if (this.props.changePage) {
            this.props.changePage(pageNo);
        } else this.props.getList(pageNo);
    }

    prevPage() {
        this.firePageChangeEvent(this.props.pageNo - 1);
    }

    nextPage() {
        this.firePageChangeEvent(this.props.pageNo + 1);
    }
}

Paginator.propTypes = {
  totalPages: PropTypes.number,
  pageNo: PropTypes.number,
  changePage: PropTypes.func,
  getList: PropTypes.func,
};
